export default __webpack_public_path__ + "media/wallpaper/one-full-34dcfc6c.jpg";